export default __webpack_public_path__ + "static/hodl-hands-d7f6406e1ac3e48d7a0a93310d1efe67.png";